/* template */
<template minapp="mpx" xlang="wxml"><div class="es-field"><div class="es-field__inner"><mpx-textarea fixed :style="[(innerTextAreaStyle)] | transRpxStyle" :value="innerValue" mpxModelEvent="input" @mpxModel='__model("innerValue", $event, ["value"], undefined)' :focus="(focus)" :cursor="(cursor)" :auto-focus="(autoFocus)" :disabled="(disabled)" :maxlength="(maxlength)" :placeholder="(placeholder)" :auto-height="(!!autoHeight)" @blur="onBlur" @focus="onFocus" @linechange="onLineChange" @keypress="onKeyPress" @input="onInput" :placeholder-style="(placeholderStyle)" class="es-field__body" :class='[$attrs["custom-class"],(classnames)]' v-if="(type === 'textarea')"/><mpx-input fixed :value="innerValue" mpxModelEvent="input" @mpxModel='__model("innerValue", $event, ["value"], undefined)' :type="(type)" :focus="(focus)" :cursor="(cursor)" :auto-focus="(autoFocus)" :disabled="(disabled)" :maxlength="(maxlength)" :placeholder="(placeholder)" :password="(password || type === 'password')" @blur="onBlur" @focus="onFocus" @input="onInput" class="es-field__body" :class='[$attrs["custom-class"],(classnames)]' v-else/></div><div class="value-number" v-if="(type === 'textarea'&& hasCountDown)">{{valueNumber + '/' + maxlength}}</div></div></template>

/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"m69975464"}'>
  @import '../common/style/bem'

  +b('field')
    display flex
    align-items center
    +e('inner')
      flex 1
    +e('body')
      box-sizing border-box
      width 100%
      height 24px
      resize none
      background-color transparent
      text-align left
      line-height 24px
      -webkit-appearance none //是为了去除内阴影样式，但是缺点是不可输入；
      -webkit-user-select auto// 解决输入问题
    +e('clear')
      display inline-block
      width 20px
      height 20px
      line-height 20px
      font-size 12px
      background #eee
      overflow hidden
      text-align center
      border-radius 100%
    +m('border')
      border 1px solid #333
  .es-field
    position relative
  .value-number
    position absolute
    right 10px
    bottom 5px  
    font-size 13px
    color #999999  
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m69975464"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex69975464%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex69975464%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m69975464"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index69975464/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'mpx-textarea':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-textarea.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
